import { SaSet } from './types';

const mw: SaSet = {
  categories: [
    'Bronnen beoordelen',
    'Nepnieuws & manipulatie',
    'Algoritmes & filterbubbels',
    'Beeld & video',
    'Bewust delen',
  ],
  items: [
    // Bronnen beoordelen
    {
      category: 'Bronnen beoordelen',
      text: 'Als ik iets opvallends lees, kijk ik eerst wie het eigenlijk heeft geplaatst.',
      quick: true,
    },
    {
      category: 'Bronnen beoordelen',
      text: 'Ik check een verhaal bij een tweede plek voordat ik het geloof.',
    },
    {
      category: 'Bronnen beoordelen',
      text: 'Ik merk het verschil tussen een nieuwsbericht en een mening.',
    },
    {
      category: 'Bronnen beoordelen',
      text: 'Ik kijk hoe oud een bericht is, want soms is het al lang achterhaald.',
    },
    {
      category: 'Bronnen beoordelen',
      text: 'Een vlotte website maakt voor mij nog niet automatisch een betrouwbaar verhaal.',
    },
    {
      category: 'Bronnen beoordelen',
      text: 'Bij een kop die te mooi lijkt om waar te zijn, lees ik eerst het hele stuk.',
    },

    // Nepnieuws & manipulatie
    {
      category: 'Nepnieuws & manipulatie',
      text: 'Ik herken vaak wanneer een bericht vooral bedoeld is om me boos te maken.',
      quick: true,
    },
    {
      category: 'Nepnieuws & manipulatie',
      text: 'Voordat ik een appbericht doorstuur, vraag ik me af of het wel echt klopt.',
      quick: true,
    },
    {
      category: 'Nepnieuws & manipulatie',
      text: 'Ik trap niet zomaar in een bericht dat me onder druk zet om snel iets te doen.',
    },
    {
      category: 'Nepnieuws & manipulatie',
      text: 'Ik merk wanneer een verhaal alleen de helft vertelt om me iets te laten denken.',
    },
    {
      category: 'Nepnieuws & manipulatie',
      text: 'Ik weet dat een verhaal niet waar wordt doordat veel mensen het delen.',
    },
    {
      category: 'Nepnieuws & manipulatie',
      text: 'Ik blijf rustig bij een bericht dat me schrik probeert aan te jagen.',
    },

    // Algoritmes & filterbubbels
    {
      category: 'Algoritmes & filterbubbels',
      text: 'Ik besef dat mijn tijdlijn me vooral laat zien wat ik toch al leuk vind.',
      quick: true,
    },
    {
      category: 'Algoritmes & filterbubbels',
      text: 'Ik snap dat aanbevelingen me langer aan het scherm proberen te houden.',
      quick: true,
    },
    {
      category: 'Algoritmes & filterbubbels',
      text: 'Ik weet dat twee mensen bij dezelfde zoekopdracht heel andere resultaten kunnen krijgen.',
    },
    {
      category: 'Algoritmes & filterbubbels',
      text: 'Ik zoek af en toe bewust naar een ander geluid dan mijn tijdlijn me voorschotelt.',
    },
    {
      category: 'Algoritmes & filterbubbels',
      text: 'Ik merk dat ik door veel klikken op één onderwerp steeds meer van hetzelfde te zien krijg.',
    },
    {
      category: 'Algoritmes & filterbubbels',
      text: 'Ik realiseer me dat de volgorde van mijn berichten niet zomaar toevallig is.',
    },

    // Beeld & video
    {
      category: 'Beeld & video',
      text: 'Bij een opvallende foto vraag ik me af of die misschien bewerkt is.',
      quick: true,
    },
    {
      category: 'Beeld & video',
      text: 'Ik weet dat een nieuwsfoto bij een heel ander verhaal kan zijn gemaakt dan waar hij nu bij staat.',
    },
    {
      category: 'Beeld & video',
      text: 'Ik besef dat tegenwoordig ook een filmpje of stem nep kan zijn.',
      quick: true,
    },
    {
      category: 'Beeld & video',
      text: 'Bij een schokkende afbeelding kijk ik of die ergens vaker en met dezelfde uitleg opduikt.',
    },
    {
      category: 'Beeld & video',
      text: 'Ik let erop dat een kort fragment een heel verkeerd beeld kan geven van wat er echt gebeurde.',
    },
    {
      category: 'Beeld & video',
      text: 'Ik weet dat een mooi plaatje gemaakt kan zijn om me een bepaald gevoel te geven.',
    },

    // Bewust delen
    {
      category: 'Bewust delen',
      text: 'Voordat ik iets deel, denk ik even na of het wel klopt.',
      quick: true,
    },
    {
      category: 'Bewust delen',
      text: 'Ik herken reclame ook als die er als een gewone tip of post uitziet.',
    },
    {
      category: 'Bewust delen',
      text: 'Ik let erop wat ik over anderen plaats, zoals een foto met iemand erop.',
    },
    {
      category: 'Bewust delen',
      text: 'Ik bedenk dat een bericht veel verder kan komen dan de groep waarvoor ik het bedoel.',
    },
    {
      category: 'Bewust delen',
      text: 'Als ik iets per ongeluk verkeerd heb gedeeld, durf ik dat recht te zetten.',
    },
    {
      category: 'Bewust delen',
      text: 'Ik denk na voor ik in een drukke discussie online meteen reageer.',
    },
  ],
};

export default mw;
